

export const peopleColour = '#08a8a8'
// export const connectionsColour = '#ce740e'
export const connectionsColour = '#EE6C4D'
export const skillsColour = '#2b23c4'
export const desiredSkillColour = '#f9f9f9'
export const currentSkillColour = '#b78d5d'



// WEBPACK FOOTER //
// ./src/styles/theme.js